import styled from '@emotion/styled'
import React, { forwardRef } from 'react'
import { variant } from 'styled-system'

import Box, { BoxProps } from './Box'

const Input = styled(Box)`
  appearance: none;
  border: none;
  background-color: transparent;
  -moz-appearance: none;
  -webkit-appearance: none;
  &:focus {
    outline: none;
  }
  ${variant({
    variants: {
      default: {
        fontFamily: 'heading',
        fontSize: [16, 16, 21.5],
        lineHeight: ['100%', '135%', '100%'],
        letterSpacing: ['0.02em', '0.015em', '0.02em'],
        fontWeight: ['600', '600', '600'],
        color: 'primaryPaleWhite',
        height: 46,
        // px: 2,
        border: '2px solid black',
        borderColor: 'primaryBrightBlue',
        borderRadius: 8,
      },
      searchBar: {
        backgroundColor: '#0000',
        color: '#F7F9FA',
        border: 'unset',
        height: '24px',
        outline: 'none',
        lineHeight: '24px',
        fontSize: '24px',
      },
      email: {
        fontFamily: 'heading',
        fontSize: 16,
        lineHeight: '100%',
        letterSpacing: '0.015em',
        fontWeight: 500,
        backgroundColor: '#F1F2F2',
        color: '#12192B',
        border: '1px solid #061121',
        borderRadius: '37px',
        height: '48px',
        padding: '4px 145px 4px 24px',
        '::placeholder': {
          color: '#9EA1A2',
        },
      },
    },
  })}
`

interface ForwardedInputProps extends BoxProps {
  variant?: 'default' | 'searchBar' | 'email'
  type?: string
}

const ForwardedInput = forwardRef<HTMLAllCollection, ForwardedInputProps>(
  ({ variant = 'default', type = 'text', ...props }, ref) => {
    return (
      <Input
        variant={variant}
        type={type}
        {...props}
        ref={ref}
        as="input"
        className="fs-mask"
      />
    )
  }
)

ForwardedInput.displayName = 'Input'

export default ForwardedInput
